/**
* Featured Services JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Services component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'featured-services',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.featured-services' ).length ) {
        $( '.featured-services' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            gap: '32px',
            perPage: 2,
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              1269: {
                perPage: 2,
              },
              768: {
                perPage: 1,
              },
            },
          } ).mount( {} );

          splide.on( 'overflow', function( isOverflow ) {
            splide.options = {
              arrows: isOverflow,
              drag: isOverflow,
            };
          } );
        } );
      }

      const cards = document.querySelectorAll( '.featured-services__splide .splide__slide .featured-services__card' );

      cards.forEach( ( card ) => {
        const title = card.querySelector( '.featured-services__card-title' );
        const description = card.querySelector( '.featured-services__card-description' );

        if ( !title || !description ) return;

        // Initially hide description off the bottom
        gsap.set( description, {yPercent: 120} );

        card.addEventListener( 'mouseenter', () => {
          const descHeight = description.offsetHeight;

          gsap.to( title, {y: -descHeight - 16, duration: 0.3, ease: 'power2.out'} );
          gsap.to( description, {yPercent: 0, duration: 0.3, ease: 'power2.out'} );
        } );

        card.addEventListener( 'mouseleave', () => {
          gsap.to( title, {y: 0, duration: 0.5, ease: 'power2.in'} );
          gsap.to( description, {yPercent: 120, duration: 0.5, ease: 'power2.in'} );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-services', COMPONENT );
} )( app );
